import React from "react";
import { StaticDeploymentSection } from "./static-app-display/static-app-deployment";
import { ServiceDeploymentSection } from "./service-display/service-deployment";
export var ShardView = function (_a) {
    var serviceName = _a.serviceName, hideShardInfo = _a.hideShardInfo, microsEnvironments = _a.microsEnvironments, shard = _a.shard, serviceAdminUsers = _a.serviceAdminUsers;
    var label = shard.label, environments = shard.environments;
    var getMicrosEnv = function (envRegion) {
        return microsEnvironments.find(function (e) { return e.id === envRegion; });
    };
    // Sort environments to display
    if (environments) {
        environments.items.sort(function (a, b) {
            var aVal = a.id.includes("prod") ? 0 : a.id.includes("dev") ? 2 : 1;
            var bVal = b.id.includes("prod") ? 0 : b.id.includes("dev") ? 2 : 1;
            // Sort by env type first
            if (aVal != bVal) {
                return aVal < bVal ? -1 : 1;
            }
            // If env types are the same, sort alphabetically
            return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
        });
    }
    if ((environments === null || environments === void 0 ? void 0 : environments.__typename) === "MicrosServiceEnvironments") {
        return (React.createElement(React.Fragment, null, environments.items.map(function (environment) {
            var microsEnv = getMicrosEnv(environment.name);
            return (React.createElement(ServiceDeploymentSection, { hideLabelInfo: hideShardInfo, deployments: environment.deployments, microsEnv: microsEnv, label: label, serviceAdminUsers: serviceAdminUsers }));
        })));
    }
    else if ((environments === null || environments === void 0 ? void 0 : environments.__typename) === "MicrosStaticEnvironments") {
        return (React.createElement(React.Fragment, null, environments.items.map(function (environment) {
            var microsEnv = getMicrosEnv(environment.name);
            return (React.createElement(StaticDeploymentSection, { serviceName: serviceName, hideLabelInfo: hideShardInfo, microsEnv: microsEnv, label: label }));
        })));
    }
    return React.createElement(React.Fragment, null);
};
